// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginServerSelectStep__content-dcffbc {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.LoginServerSelectStep__new-server-title-a1ceea {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginViews/LoginServerSelectStep/LoginServerSelectStep.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.new-server-title {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `LoginServerSelectStep__content-dcffbc`,
	"new-server-title": `LoginServerSelectStep__new-server-title-a1ceea`,
	"newServerTitle": `LoginServerSelectStep__new-server-title-a1ceea`
};
module.exports = ___CSS_LOADER_EXPORT___;
